const TOKEN_KEY = 'kivonex-admin-token';
/**
 * Where the Kivonex Cloud API is. Blank (the default) means this site's own /v1, which the dev server forwards;
 * a production build served on its own address sets REACT_APP_KIVONEX_API (https://backend.kivonex.in).
 */
export const API_BASE = (process.env.REACT_APP_KIVONEX_API ?? '').replace(/\/+$/, '');
export function apiUrl(path) {
    return `${API_BASE}${path}`;
}
export function getToken() {
    return sessionStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
    sessionStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
    sessionStorage.removeItem(TOKEN_KEY);
}
export async function api(path, init) {
    const headers = new Headers(init?.headers);
    if (init?.body)
        headers.set('Content-Type', 'application/json');
    const token = getToken();
    if (token)
        headers.set('Authorization', `Bearer ${token}`);
    const response = await fetch(apiUrl(path), { ...init, headers });
    const body = (await response.json().catch(() => ({})));
    if (response.status === 401) {
        clearToken();
        window.dispatchEvent(new Event('kivonex-admin-unauthorized'));
    }
    if (!response.ok) {
        throw new Error(body.error?.message ?? 'Request failed');
    }
    return body;
}
/** Ends this admin session on the server, then forgets it here. */
export async function signOut() {
    await api('/v1/admin/session', { method: 'DELETE' }).catch(() => undefined);
    clearToken();
}
/** Admin sign-in, step 1: a one-time code for the mobile number. */
export function requestSignInCode(mobile) {
    return api('/v1/admin/session/code', { method: 'POST', body: JSON.stringify({ mobile }) });
}
/** Admin sign-in, step 2: the mobile number and its code. */
export function signIn(mobile, code) {
    return api('/v1/admin/session', { method: 'POST', body: JSON.stringify({ mobile, code }) });
}
/** A mobile number as shown: +91 73640 76458. */
export function showMobile(mobile) {
    return mobile.length === 10 ? `+91 ${mobile.slice(0, 5)} ${mobile.slice(5)}` : mobile;
}
